var map = {
	"./apt-employee/apt-employee.module": [
		"./src/app/apt-employee/apt-employee.module.ts",
		"apt-employee-apt-employee-module"
	],
	"./attendance-verification/attendance-verification.module": [
		"./src/app/attendance-verification/attendance-verification.module.ts",
		"common",
		"attendance-verification-attendance-verification-module"
	],
	"./discount/discount-module/discount-module.module": [
		"./src/app/discount/discount-module/discount-module.module.ts",
		"discount-discount-module-discount-module-module"
	],
	"./distribution/distribution-module/distribution.module": [
		"./src/app/distribution/distribution-module/distribution.module.ts",
		"distribution-distribution-module-distribution-module"
	],
	"./employee-attendance-entry/employee-attendance-entry.module": [
		"./src/app/employee-attendance-entry/employee-attendance-entry.module.ts",
		"employee-attendance-entry-employee-attendance-entry-module"
	],
	"./employee-attendance/employee-attendance.module": [
		"./src/app/employee-attendance/employee-attendance.module.ts",
		"employee-attendance-employee-attendance-module"
	],
	"./employee-pay-slip/employee-pay-slip.module": [
		"./src/app/employee-pay-slip/employee-pay-slip.module.ts",
		"employee-pay-slip-employee-pay-slip-module"
	],
	"./gate-pass/gate-pass.module": [
		"./src/app/gate-pass/gate-pass.module.ts",
		"gate-pass-gate-pass-module"
	],
	"./hr-recruitment/hr-recruitment.module": [
		"./src/app/hr-recruitment/hr-recruitment.module.ts",
		"default~hr-recruitment-hr-recruitment-module~induction-induction-module~interview-interview-module~i~caee601a",
		"common",
		"hr-recruitment-hr-recruitment-module"
	],
	"./induction/induction.module": [
		"./src/app/induction/induction.module.ts",
		"default~hr-recruitment-hr-recruitment-module~induction-induction-module~interview-interview-module~i~caee601a",
		"common",
		"induction-induction-module"
	],
	"./interview/interview.module": [
		"./src/app/interview/interview.module.ts",
		"default~hr-recruitment-hr-recruitment-module~induction-induction-module~interview-interview-module~i~caee601a",
		"common",
		"interview-interview-module"
	],
	"./inv-mgmt/inv-mgmt-module/inv-mgmt.module": [
		"./src/app/inv-mgmt/inv-mgmt-module/inv-mgmt.module.ts",
		"inv-mgmt-inv-mgmt-module-inv-mgmt-module"
	],
	"./it-resource/it-resource.module": [
		"./src/app/it-resource/it-resource.module.ts",
		"default~hr-recruitment-hr-recruitment-module~induction-induction-module~interview-interview-module~i~caee601a",
		"common",
		"it-resource-it-resource-module"
	],
	"./master/otp-list-module/otp-list.module": [
		"./src/app/master/otp-list-module/otp-list.module.ts",
		"master-otp-list-module-otp-list-module"
	],
	"./order/primary-order-module/primary-order.module": [
		"./src/app/order/primary-order-module/primary-order.module.ts",
		"order-primary-order-module-primary-order-module"
	],
	"./patrol/patrol.module": [
		"./src/app/patrol/patrol.module.ts",
		"patrol-patrol-module"
	],
	"./performance/performance.module": [
		"./src/app/performance/performance.module.ts",
		"default~hr-recruitment-hr-recruitment-module~induction-induction-module~interview-interview-module~i~caee601a",
		"common",
		"performance-performance-module"
	],
	"./petrol-tracker/petrol-tracker-module/petrol-tracker.module": [
		"./src/app/petrol-tracker/petrol-tracker-module/petrol-tracker.module.ts",
		"petrol-tracker-petrol-tracker-module-petrol-tracker-module"
	],
	"./plant-employee/plant-employee.module": [
		"./src/app/plant-employee/plant-employee.module.ts",
		"common",
		"plant-employee-plant-employee-module"
	],
	"./product/product-module/product.module": [
		"./src/app/product/product-module/product.module.ts",
		"product-product-module-product-module"
	],
	"./resignation/resignation.module": [
		"./src/app/resignation/resignation.module.ts",
		"resignation-resignation-module"
	],
	"./salary-calculator/salary-calculator.module": [
		"./src/app/salary-calculator/salary-calculator.module.ts",
		"salary-calculator-salary-calculator-module"
	],
	"./security-attendance/security-attendance.module": [
		"./src/app/security-attendance/security-attendance.module.ts",
		"security-attendance-security-attendance-module"
	],
	"./security-portal/security-portal.module": [
		"./src/app/security-portal/security-portal.module.ts",
		"security-portal-security-portal-module"
	],
	"./segment-list/segment-module/segment.module": [
		"./src/app/segment-list/segment-module/segment.module.ts",
		"segment-list-segment-module-segment-module"
	],
	"./shortcut/shortcut.module": [
		"./src/app/shortcut/shortcut.module.ts",
		"shortcut-shortcut-module"
	],
	"./subcategory/subcategory-module/subcategory.module": [
		"./src/app/subcategory/subcategory-module/subcategory.module.ts",
		"subcategory-subcategory-module-subcategory-module"
	],
	"./ui-kit/ui-kit.module": [
		"./src/app/ui-kit/ui-kit.module.ts",
		"default~hr-recruitment-hr-recruitment-module~induction-induction-module~interview-interview-module~i~caee601a",
		"common",
		"ui-kit-ui-kit-module"
	],
	"./user-vacancy/user-vacancy.module": [
		"./src/app/user-vacancy/user-vacancy.module.ts",
		"user-vacancy-user-vacancy-module"
	],
	"./user/user-module/user.module": [
		"./src/app/user/user-module/user.module.ts",
		"user-user-module-user-module"
	],
	"./userdesignation/userdesignation-module/userdesignation.module": [
		"./src/app/userdesignation/userdesignation-module/userdesignation.module.ts",
		"userdesignation-userdesignation-module-userdesignation-module"
	],
	"./visitor/visitor.module": [
		"./src/app/visitor/visitor.module.ts",
		"visitor-visitor-module"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		var id = ids[0];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;